import { render, staticRenderFns } from "./DocumentsUpload.vue?vue&type=template&id=7f84703f&"
import script from "./DocumentsUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentsUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports